import {BasicCriteria} from '../../../../allkey/framework/parameters/BasicCriteria';

export class ProcessCriteriaExt extends BasicCriteria {
visionCode: string;
}

